<template>
<div class="xin">
    <div class="switch">
        <el-tabs v-show="list_one">
            <!-- 数据统计  -->

            <el-tab-pane label="数据统计">
                <span slot="label">
                    {{ $t("logs.statistics13") }}
                </span>
                <div class="switch1">

                    <!-- 查询框 -->
                    <div class="main">
                        <div class="main-find">
                            <span class="span">{{ $t("logs.statistics1") }}</span>

                            <el-select v-model="q_minion_host1" placeholder="" @change="change1" style="width:15%" v-if="this.has_minion==1">
                                <el-option v-for="item in q_minion_host" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                            <el-select v-model="type" placeholder="" @change="change2">
                                <el-option v-for="item in typee" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                            <el-button type="primary" @click="download()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.statistics2") }}</el-button>
                            <el-select v-model="selecttype" placeholder="">
                                <el-option v-for="item in selecttypee" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                            <!-- <el-switch
  v-model="chart_type"
  @change="chart_table"
  :active-text="$t('logs.statistics_chart')"
  :inactive-text="$t('logs.statistics_table')">
</el-switch> -->
                        </div>

                    </div>
                    <!-- 弹出框2-->

                    <div class="table">
                        <el-table v-loading="loading" :data="fileList5" :row-class-name="tableRowClassName" ref="multipleTable" tooltip-effect="dark" style="width: 100%" v-if="this.chart_show_type==1">
                            <el-table-column prop="DATE" :label="$t('logs.statistics3')" width="120">
                            </el-table-column>
                            <el-table-column prop="FM_NEW_STAT_CONNECT" :label="$t('logs.statistics4')">
                            </el-table-column>
                            <el-table-column prop="FM_NEW_STAT_MSGS" :label="$t('logs.statistics5')" width="80">
                            </el-table-column>
                            <el-table-column prop="FM_NEW_STAT_ALL_REJ" :label="$t('logs.statistics6')" width="120">
                            </el-table-column>
                            <el-table-column prop="FM_NEW_STAT_ENVTO" :label="$t('logs.statistics7')" width="90">
                            </el-table-column>
                            <el-table-column prop="FM_NEW_STAT_VIRUS" :label="$t('logs.statistics8')" width="70">
                            </el-table-column>
                               <el-table-column prop="FM_SPAM_EVIL" :label="$t('logs.statistics17')" width="70">
                            </el-table-column>
                               <el-table-column prop="FM_SPAM_PISH" :label="$t('logs.statistics18')" width="70">
                            </el-table-column>
                            <el-table-column prop="FM_NEW_STAT_IP_BLACK" :label="$t('logs.statistics9')">
                            </el-table-column>
                            <el-table-column prop="FM_NEW_STAT_SPF_ERR" :label="$t('logs.statistics10')">
                            </el-table-column>
                            <el-table-column prop="FM_NEW_STAT_RCPT_UNKNOWN" :label="$t('logs.statistics11')" width="150">
                            </el-table-column>
                            <el-table-column prop="FM_NEW_STAT_BYTES" :label="$t('logs.statistics12')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="80" v-if="this.type_date==1">
                                <template slot-scope="scope">
                                    <!-- 操作 当天数据-->

                                    <el-button @click="handleClick1(scope.$index, scope.row)" type="text" size="small">{{ $t("logs.statistics14") }}</el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                         <div id="data_statistics" v-else ref="chart"></div>
                    </div>
                </div>
            </el-tab-pane>

        </el-tabs>

        <div class="switch1" v-show="list_two" v-loading="loading">

            <!-- 查询框 -->
            <div class="main">
                <div class="main-find" style="margin-top:14px">
                    <span class="span">{{ this.show_hint1 }}</span>
                    <el-button @click="save_sender_hide()">{{ $t("logs.Policy_back") }}</el-button>
                    <el-button type="primary" @click="down_type1()" :disabled="$root.jurisdiction.only_query==0">{{this.show_hint2 }}</el-button>
                    <el-select v-model="selecttype1" placeholder="按天统计" style="margin-right:10px;">
                        <el-option v-for="item in selecttype1_arr" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>

            </div>
            <!-- 弹出框2-->

            <!--  表格 -->
            <div class="table">
                <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList2" :row-class-name="tableRowClassName">
                    <el-table-column prop="ITEM" :label="$t('logs.statistics15')" width="80">
                    </el-table-column>
                    <el-table-column prop="TOTAL" :label="$t('logs.statistics16')" width="60">
                    </el-table-column>
                    <el-table-column prop="HOUER0" :label="$t('0')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER1" :label="$t('1')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER2" :label="$t('2')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER3" :label="$t('3')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER4" :label="$t('4')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER5" :label="$t('5')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER6" :label="$t('6')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER7" :label="$t('7')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER8" :label="$t('8')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER9" :label="$t('9')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER10" :label="$t('10')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER11" :label="$t('11')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER12" :label="$t('12')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER13" :label="$t('13')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER14" :label="$t('14')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER15" :label="$t('15')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER16" :label="$t('16')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER17" :label="$t('17')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER18" :label="$t('18')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER19" :label="$t('19')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER20" :label="$t('20')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER21" :label="$t('21')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER22" :label="$t('22')" width="50">
                    </el-table-column>
                    <el-table-column prop="HOUER23" :label="$t('23')" width="50">
                    </el-table-column>

                </el-table>
            </div>
        </div>

    </div>
    <!-- 查询框 -->

    <!--  底部 -->
</div>
</template>

<script>
// import "echarts/lib/component/toolbox";

export default {
    data() {
        return {
            selecttype1: 'pdf',
            selecttype1_arr: [],
            type_date: '',
            selecttypee: [],
            selecttype: 'csv',
            type: '',
            typee: [],
            has_minion: '',
            list_one: true,
            list_two: false,
            q_minion_host: [],
            q_minion_host1: '127.0.0.1',
            xian: false,
            btnText: "展示更多",
            checked: "",
            form: {
                username: "",
            },
            value: "",

            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "按天统计",
                },
                {
                    value: "选项2",
                    label: "按周统计",
                },
                {
                    value: "选项3",
                    label: "按月统计",
                },
                {
                    value: "选项4",
                    label: "按年统计",
                },
            ],
            loading: false,
            emali: "",
            fileList1: [],
            fileList2: [],
            fileList5: [],
            show_hint1: '',
            show_hint2: '',
            date_day: '',
            chart_type:false,
            chart_show_type:1,

        };
    },
    mounted() {
        this.getFileList1();
        // this.getFileList2();

    },
    methods: {
        // 当天数据
        handleClick1(index, scope) {
            this.loading = true
            // console.log(index, scope)
            this.list_one = false
            this.list_two = true
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let date = scope.DATE

            let str = this.$qs.stringify({
                __mode: "print_oneday_stat",
                sid: sid,
                date: date,
                minion_ip: this.q_minion_host1,

            });

            this.$axios
                .post("/api/adm/cgi/mon.cgi", str)
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false;

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false;

                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.loading = false;
                        this.fileList2 = res.data.ret.datalist;
                        this.show_hint1 = res.data.ret.LOAD_HINT1
                        this.show_hint2 = res.data.ret.LOAD_HINT2
                        this.selecttype1_arr = res.data.ret.q_type
                        this.date_day = res.data.ret.DATE
                    }
                });

        },
        // 数据统计加载
        getFileList2() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "print_oneday_stat",
                        sid: sid,

                    },
                })
                .then((res) => {
                    console.log(res);

                  if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                      
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;

                    }
                })
               ;
        },
        // 数据统计加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "cmd_print_eachday_stat",
                        sid: sid,

                    },
                })
                .then((res) => {
                    console.log(res);

                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                       
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList5 = res.data.ret.datalist;
                        this.q_minion_host = res.data.ret.q_minion_host
                        this.typee = res.data.ret.q_type
                        this.type = res.data.ret.q_type[0].label
                        this.selecttypee = res.data.ret.q_print
                        if (res.data.ret.HAS_MINION) {
                            this.has_minion = 1
                        }
                        if (res.data.ret.TYPE_DATE) {
                            this.type_date = 1
                        }

                    }
                })
               ;
        },
        chart_table(val){
                console.log(val)
                if(val==true){
                 
                    this.chart_show_type=0;
                    setTimeout(() => {
                    this.datatable_statistics()
       
      }, 100);
                }else{
                    this.chart_show_type=1
                }
            
        },
          // 柱状图

    datatable_statistics() {
      // 基于准备好的dom，初始化echarts实例
      // 如果想要修改默认配置参数，可以通过如下方式


    //   let myChart = this.$echarts.init(document.getElementById("data_statistics"));
      let myChart = this.$echarts.init(this.$refs.chart);
      // 绘制图表

      myChart.showLoading({
        text: "loading",
        color: "#c23531",
        textColor: "#000",
        maskColor: "rgba(255, 255, 255, 0.2)",
        zlevel: 0,
      });
      setTimeout(() => {
        // setOption前隐藏loading事件
        myChart.hideLoading();
        myChart.setOption(option);
      }, 1000);

      const option = {
    backgroundColor: '#fff',

    tooltip: {
        trigger: 'axis',
        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
        }
    },
    legend: {
         type: "plain",
          top: "2vh", // 图列相对容器的位置 top\bottom\left\right
        //   right: "0",
         textStyle: {
            // 图列内容样式

            fontfamily: "PingFangSC-RegularPingFang SC",

            color: "#818EA8", // 字体颜色

            fontweight: "400",

            backgroundColor: "#fff", // 字体背景色
          },
        data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎', '百度', '谷歌', '必应', '其他']
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: [
        {
            type: 'category',
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
        }
    ],
    yAxis: [
        {
            type: 'value'
        }
    ],
    series: [
        {
            name: '直接666访问',
            type: 'bar',
            emphasis: {
                focus: 'series'
            },
            data: [320, 332, 301, 334, 390, 330, 320]
        },
        {
            name: '邮件营销',
            type: 'bar',
            stack: '广告',
            emphasis: {
                focus: 'series'
            },
            data: [120, 132, 101, 134, 90, 230, 210]
        },
        {
            name: '联盟广告',
            type: 'bar',
            stack: '广告',
            emphasis: {
                focus: 'series'
            },
            data: [220, 182, 191, 234, 290, 330, 310]
        },
        {
            name: '视频广告',
            type: 'bar',
            stack: '广告',
            emphasis: {
                focus: 'series'
            },
            data: [150, 232, 201, 154, 190, 330, 410]
        },
        {
            name: '搜索引擎',
            type: 'bar',
            data: [862, 1018, 964, 1026, 1679, 1600, 1570],
            emphasis: {
                focus: 'series'
            },
            // markLine: {
            //     lineStyle: {
            //         type: 'dashed'
            //     },
            //     data: [
            //         [{type: 'min'}, {type: 'max'}]
            //     ]
            // }
        },
        {
            name: '百度',
            type: 'bar',
            barWidth: 5,
            stack: '搜索引擎',
            emphasis: {
                focus: 'series'
            },
            data: [620, 732, 701, 734, 1090, 1130, 1120]
        },
        {
            name: '谷歌',
            type: 'bar',
            stack: '搜索引擎',
            emphasis: {
                focus: 'series'
            },
            data: [120, 132, 101, 134, 290, 230, 220]
        },
        {
            name: '必应',
            type: 'bar',
            stack: '搜索引擎',
            emphasis: {
                focus: 'series'
            },
            data: [60, 72, 71, 74, 190, 130, 110]
        },
        {
            name: '其他',
            type: 'bar',
            stack: '搜索引擎',
            emphasis: {
                focus: 'series'
            },
            data: [62, 82, 91, 84, 109, 110, 120]
        }
    ]
};

    },
        // 下拉框点击选中
        change1(a) {
            // console.log(a);
            this.loading = true;
            this.q_minion_host1 = a
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            let salt_minion_ip =
                this.q_minion_host1
            let type = this.type
            // console.log(type)
            // let stat_type =
            //     this.stat_type1 == "" ? this.mstat_type1 : this.stat_type1;
            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "cmd_print_eachday_stat",
                        sid: sid,
                        salt_minion_ip: salt_minion_ip,
                        type: type,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res);
                    // console.log(col, "传的col值");

                    // console.log(this.col1, "传的col1值");
                    // console.log(this.page, '222')

                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        alert("请重新登录");
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList5 = res.data.ret.datalist;
                      
                        this.loading = false;
                        if (res.data.ret.TYPE_DATE) {
                            this.type_date = 1
                        }
                        console.log(this.type_date, '1111')

                    }
                });
        },
        change2(a) {
            // console.log(a);
            this.loading = true;
            this.type = a
            this.type_date = 0
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            let salt_minion_ip =
                this.q_minion_host1
            let type = this.type
            // console.log(type)
            // let stat_type =
            //     this.stat_type1 == "" ? this.mstat_type1 : this.stat_type1;
            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "cmd_print_eachday_stat",
                        sid: sid,
                        salt_minion_ip: salt_minion_ip,
                        type: type,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res);
                    // console.log(col, "传的col值");

                    // console.log(this.col1, "传的col1值");
                    // console.log(this.page, '222')

                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        alert("请重新登录");
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList5 = res.data.ret.datalist;
                       
                        this.loading = false;
                        if (res.data.ret.TYPE_DATE) {
                            this.type_date = 1
                        }
                        console.log(this.type_date, '1111')

                    }
                });
        },
        down_type1() {
            // console.log(this.selecttype, '文件类型')
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            // let __mode = "print_static_csv";
            let __mode = "print_oneday_stat";
            let date = this.date_day
            let selecttype = this.selecttype1
            // console.log(selecttype);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(`/api/adm/cgi/mon.cgi?sid=${sid}&__mode=${__mode}&printtype=${selecttype}&printtofile=1&date=${date}`);

        },
        // 下载统计数据
        download() {
            // console.log(this.selecttype, '文件类型')
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // csv
            if (this.selecttype == 'csv') {

                let __mode = "print_static_csv";
                // let __mode1 = "cmd_print_eachday_stat";
                let minion_ip = this.q_minion_host1
                let type = this.type
                let selecttype = this.selecttype
                // console.log(__mode);

                // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
                window.open(`/api/adm/cgi/mon.cgi?__mode=${__mode}&sid=${sid}&salt_minion_ip_stat_data=${minion_ip}&down_type=${type}&selecttype=${selecttype}&show_all_detail=1`);
            }
            if (this.selecttype == 'html' || this.selecttype == 'pdf') {

                // let __mode = "print_static_csv";
                let __mode = "cmd_print_eachday_stat";
                let minion_ip = this.q_minion_host1
                let type = this.type
                let selecttype = this.selecttype
                // console.log(__mode);

                // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
                window.open(`/api/adm/cgi/mon.cgi?__mode=${__mode}&sid=${sid}&salt_minion_ip=${minion_ip}&type=${type}&printtype=${selecttype}&printtofile=1`);
            }
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
            this.tanchu1 = false;
        },
        tan4: function () {
            this.tanchu = true;
            //   this.tanchu1 = false;
        },
        tanOff: function () {
            this.tanchu = false;
            //   this.tanchu1 = false;
        },
        // 返回
        save_sender_hide() {
            this.list_two = false;
            this.list_one = true
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

.main-find {
    width: 100%;
    height: 50px;
    padding-left: 10px;
    // padding-bottom: 5px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: left;

    border: 2px solid #D2D7E6;
    background: #FFFFFF;

    span {
        margin-right: 8px;

        // width: 126px;
        // display: inline-block;
        color: #0E2C5E;
    }

    .el-input {
        margin-right: 8px;
        width: 20%;
        line-height: 26px;
        height: 26px;
        // padding: 5px 10px 5px 0;

    }

    // input 框高度
    /deep/ .el-input__inner {
        height: 32px;
        padding: 0 6px;
    }

    /deep/ .el-select {
        margin-right: 10px;
    }

    /deep/ .el-button {
        margin-right: 10px;
        // margin-left: 30px;
    }
}

// 隐藏滚动条
// .el-table ::-webkit-scrollbar {
//     width: 0px;
//     background: none;
// }

/deep/ .el-tabs__nav {
    padding-left: 16px;
}

.el-button+.el-button {
    margin-left: 0;
}
.cell img{
    width: 16px;
    height: 16px;
    display: block;
}
/deep/ .el-tabs__header{
    margin: 0 0 9px;
}
#data_statistics{
    height: calc(70vh - 60px);
}
</style>
